// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/preferential-runway-selection.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/preferential-runway-selection/preferential-runway-selection.js';

mount([g0]);
